<template>
    <div class="features">
        <div class="feature">
            <div class="title">{{ feature1Title }}</div>
            <div class="box">
                {{ feature1Text }}
            </div>
        </div>
        <div class="feature">
            <div class="title">{{ feature2Title }}</div>
            <div class="box">
                {{ feature2Text }}
            </div>
        </div>
        <div class="feature">
            <div class="title">{{ feature3Title }}</div>
            <div class="box">
                {{ feature3Text }}
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Features',
        data: function() {
            return {
                feature1Title: "",
                feature1Text: "",
                feature2Title: "",
                feature2Text: "",
                feature3Title: "",
                feature3Text: "",
            }
        },
        mounted: function() {
            this.$root.$on('texts-changed', (texts) => {
                this.$data.feature1Title = texts[0].feature1_title;
                this.$data.feature1Text = texts[0].feature1_text;
                this.$data.feature2Title = texts[0].feature2_title;
                this.$data.feature2Text = texts[0].feature2_text;
                this.$data.feature3Title = texts[0].feature3_title;
                this.$data.feature3Text = texts[0].feature3_text;
            });
        },
    };
</script>

<style scoped lang="less">
    .features {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        grid-gap: 20px;
        padding: 50px 0px;
        padding-top: 25px;
        max-width: 1200px;
        margin: 0 auto;

        & .feature {
            display: grid;
            grid-template-rows: auto 1fr;
            grid-gap: 10px;

            & .title {
                font-weight: 700;
                font-size: 18px;
                text-align: center;
                letter-spacing: 0.2em;
                text-transform: uppercase;
            }
            & .box {
                background: #fff;
                box-shadow: 0px 2px 20px rgba(0,0,0,0.15);
                border-radius: 6px;
                padding: 25px;
                line-height: 1.5;;
            }
        }
    }

    @media screen and (max-width: 1250px) {
        .features {
            grid-template-columns: 1fr;
            padding: 25px 50px;
        }
    }
</style>
